// Popup "L'application a été mise à jour", en bas à droite.
// Le serveur renvoie dans sessionInit les versions du CHANGELOG pas encore vues (session.nouveautes) ;
// le popup reste affiché, d'une page à l'autre et après rechargement, tant qu'il n'a pas été fermé.

import { createApp } from "vue";
import { Echangeur } from "../../Echangeur";

const html = `
<transition name="notes-version">
  <div v-if="visible" class="notes-version" role="status" aria-live="polite">
    <div class="notes-version-header">
      <div class="notes-version-icon" aria-hidden="true">🎉</div>
      <div class="flex-grow-1 min-w-0">
        <div class="notes-version-title">L’application a été mise à jour</div>
        <div class="notes-version-sub">Version {{ derniere.version }} · {{ derniere.date }}</div>
      </div>
      <button type="button" class="notes-version-close" title="Fermer" aria-label="Fermer" @click="fermer">
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>
    <div class="notes-version-body">
      <div v-for="v in nouveautes" :key="v.version" class="notes-version-group">
        <div v-if="nouveautes.length > 1" class="notes-version-label">
          Version {{ v.version }} <span class="text-muted fw-normal">· {{ v.date }}</span>
        </div>
        <ul>
          <li v-for="(item, i) in v.items" :key="i" v-html="formatItem(item)"></li>
        </ul>
      </div>
    </div>
    <div class="notes-version-footer">
      <button type="button" class="btn btn-white" @click="voirHistorique">Tout l’historique</button>
      <button type="button" class="btn btn-primary" @click="fermer">Compris</button>
    </div>
  </div>
</transition>
`;

let app = null;

function echapper(texte) {
  return texte.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c]);
}

function demarre(session) {
  // Nouvelle session (ex. après une déconnexion) : on repart d'un popup propre
  if (app) {
    app.unmount();
    app = null;
  }
  document.querySelector("#notesVersion")?.remove();

  const nouveautes = (session && session.nouveautes) || [];
  if (!nouveautes.length) return;

  const el = document.createElement("div");
  el.id = "notesVersion";
  document.body.appendChild(el);

  app = createApp({
    template: html,
    data() {
      return {
        visible: false,
        nouveautes,
      };
    },
    computed: {
      derniere() {
        return this.nouveautes[0];
      },
    },
    mounted() {
      // Laisse l'écran se dessiner avant de faire apparaître le popup
      setTimeout(() => (this.visible = true), 600);
    },
    methods: {
      formatItem(texte) {
        return echapper(texte).replace(/`([^`]+)`/g, "<code>$1</code>");
      },
      // Ouvre la page Nouveautés : les notes y sont lues, le popup est fermé comme avec "Compris"
      voirHistorique() {
        window.location.hash = "#nouveautes";
        this.fermer();
      },
      async fermer() {
        this.visible = false;
        try {
          await Echangeur.rest("user.preferences.saveVersionVue", { version: this.derniere.version });
        } catch (e) {
          // Non enregistré : le popup réapparaîtra au prochain chargement, sans gêner la suite
        }
      },
    },
  });
  app.mount(el);
}

export default { demarre };
